import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import MovieCard from "@/components/MovieCard";
import { Loader2, ListVideo } from "lucide-react";

export default function MyList() {
  const [items, setItems] = useState(null);

  const load = () => api.get("/mylist").then((r) => setItems(r.data)).catch(() => setItems([]));
  useEffect(() => { load(); }, []);

  const remove = async (item) => {
    try {
      await api.delete(`/mylist/${item.id}`);
      setItems((cur) => cur.filter((c) => c.id !== item.id));
      toast.success("Removed from My List");
    } catch { toast.error("Could not remove"); }
  };

  if (items === null) return <div className="min-h-screen flex items-center justify-center bg-ink"><Loader2 className="w-8 h-8 text-brand animate-spin" /></div>;

  return (
    <div className="bg-ink min-h-screen pt-24 px-4 sm:px-12 pb-20">
      <h1 className="font-display text-3xl sm:text-4xl font-black mb-6 flex items-center gap-3"><ListVideo className="w-8 h-8 text-gold" /> My List</h1>
      {items.length === 0 ? (
        <div data-testid="mylist-empty" className="text-white/50 py-20 text-center">
          <p>Your list is empty.</p>
          <p className="text-sm mt-1">Add movies and series to watch them later.</p>
        </div>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
          {items.map((item) => (
            <div key={item.id} className="relative">
              <MovieCard item={item} fluid />
              <button
                data-testid={`remove-${item.id}`}
                onClick={() => remove(item)}
                className="absolute top-2 right-2 z-20 bg-black/70 hover:bg-brand text-white text-xs px-2 py-1 rounded transition-colors"
              >
                Remove
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
